import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './configs/import'
// 导入插件
import './plugins'

Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
